const integrationsBase = '/integrations';
const shopifyBase = `${integrationsBase}/s`;

export const IntegrationsRoutes = {
	Shopify: {
		Base: shopifyBase,
		Auth: `${shopifyBase}/auth`,
		Webhooks: `${shopifyBase}/webhooks`,
		Fulfillment: `${shopifyBase}/fulfillment`,
		App: `${shopifyBase}/app`,
	},
} as const;
